import * as React from "react";
import auth from "../../../../Auth";
import { Grid, GridColumn as Column, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { CellRender, GridNoRecord,  StatusCell } from "../../../../Shared/GridComponents/CommonComponents";
import CompleteSearch from "../../../../Shared/Search/CompleteSearch";
import ColumnMenu from "../../../../Shared/GridComponents/ColumnMenu";
import RowActions from "../../../../Shared/Workflow/RowActions";
import { State, toODataString } from "@progress/kendo-data-query";
import { Dialog } from "@progress/kendo-react-dialogs";
import { history, initialDataState, successToastr } from "../../../../../HelperMethods";
import ConfirmationModal from "../../../../Shared/ConfirmationModal";
import { faPlusCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import {
    REMOVE_CLIENT_SCHEDULE_CONFIRMATION_MSG,
    CLIENT_SCHEDULE_ACTIVE_SUCCESS_MSG,
    CLIENT_SCHEDULE_REMOVE_SUCCESS_MSG,
    ACTIVE_CLIENT_SCHEDULE_CONFIRMATION_MSG,
    INACTIVE_CLIENT_SCHEDULE_CONFIRMATION_MSG,
    CLIENT_SCHEDULE_INACTIVE_SUCCESS_MSG
} from "../../../../Shared/AppMessages";
import BreadCrumbs from "../../../../Shared/BreadCrumbs/BreadCrumbs";
import CreateSchedule from "../CreateSchedule/CreateSchedule";
import { CustomMenu, DefaultActions } from "./GlobalActions";
import clientAdminService from "../../Service/DataService";



export interface ScheduleProps {
    match: any;
    onCloseModal: any;
    location: any;
}

export interface ScheduleState {
    schedules: any[];
    clientId?: string;
    onFirstLoad: boolean;
    showLoader?: boolean;
    showAddNewScheduleModal?: any;
    showEditModal?: boolean;
    showRemoveModal?: boolean;
    showActivateModal?: boolean;
    showInactivateModal?: boolean;
    dataState: any;
    totalCount?: number;
    totalSchedule?: any;
    departmentId: string;
    locationId: string;

}

class Schedule extends React.Component<ScheduleProps, ScheduleState> {
    public dataItem: any;
    public divId: string;
    constructor(props: ScheduleProps) {
        super(props);
        const deptId = this.props.match.params.deptId;
        const locId = this.props.match.params.locId;
        this.state = {
            schedules: [],
            dataState: initialDataState,
            departmentId: deptId,
            onFirstLoad: true,
            showLoader: true,
            locationId: locId,
            clientId: auth.getClient()
        };
    }

    componentDidMount() {

    }

    getSchedules = (dataState) => {
        this.setState({ showLoader: true, onFirstLoad: false });
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;

        if (!this.state || !this.state.departmentId) return;
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;
        let deptId = this.state.departmentId;
        clientAdminService.getSchedule(deptId, queryStr).then((res) => {
            const newResults = res.data.map(result => ({
                ...result,
                status: result.recordStatus
            }))

            this.setState({
                schedules: newResults,
                dataState: dataState,
                showLoader: false
            })
            this.getSchedulesCount(dataState);

        });
    }

    getSchedulesCount = (dataState) => {
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };
        var queryStr = `${toODataString(finalState, { utcDates: true })}`;
        let deptId = this.state.departmentId;
        clientAdminService.getSchedule(deptId, queryStr).then((res) => {
            this.setState({
                totalCount: res.data.length,
                totalSchedule: res.data
            })

        });
    };

    onDataStateChange = (changeEvent) => {
        this.getSchedules(changeEvent.dataState);
        localStorage.setItem("ManageSchedule-GridDataState", JSON.stringify(changeEvent.dataState));
    };

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
        this.dataItem = dataItem;
    }

    AddNewModal = () => {
        this.dataItem = undefined
        this.setState({ showAddNewScheduleModal: true })
    }

    deleteSchedule = (id, statusId, msg) => {
        this.setState({ showRemoveModal: false, showInactivateModal: false, showActivateModal: false });
        clientAdminService.deleteSchedule(id, statusId).then((res) => {
            successToastr(msg);
            this.getSchedules(this.state.dataState);
        });
    };

    openModal = (prop, dataItem) => {

    };

    

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-none">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-10 fonFifteen paddingLeftandRight">
                            <BreadCrumbs globalData={{
                                clientId: this.state.clientId,
                                deptId: this.state.departmentId, locationId: this.state.locationId
                            }}  ></BreadCrumbs>
                        </div>
                        <div className="col-2">
                            {auth.hasPermissionV2(AppPermissions.SCHEDULE_USER_VIEW) && (
                                <span className="float-right text-dark cusrsor-pointer "
                                    onClick={() => this.setState({ showAddNewScheduleModal: true })}>
                                    <FontAwesomeIcon icon={faPlusCircle} className={"mr-2 text-dark"} />
                                    Add New Schedule
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <CompleteSearch
                        page="ManageSchedule"
                        entityType={"ManageSchedule"}
                        placeholder="Search text here!"
                        handleSearch={this.getSchedules}
                        onFirstLoad={this.state.onFirstLoad}
                        persistSearchData={true}
                    />
                    <div className="manageDivisionContainer global-action-grid-lastchild">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: true }}
                            data={this.state.schedules}
                            {...this.state.dataState}
                            //detail={ViewMoreComponent}
                            expandField="expanded"
                            total={this.state.totalCount}
                            className="kendo-grid-custom k-widget lastchild"
                        >
                            <GridNoRecords>{GridNoRecord(this.state.showLoader)}</GridNoRecords>

                            <GridColumn
                                field="scheduleName"
                                title="Schedule Name"
                                cell={(props) => CellRender(props, "scheduleName")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="recordStatus"
                                title="Status"
                                columnMenu={ColumnMenu}
                                cell={StatusCell}
                            />
                            <GridColumn
                                title="Action"
                                sortable={false}
                                width="70px"
                                cell={(props) => (
                                    <RowActions
                                        dataItem={props.dataItem}
                                        currentState={""}
                                        rowId={props.dataItem.clientDivId}
                                        handleClick={this.handleActionClick}
                                        defaultActions={DefaultActions(props, this.state.locationId)}
                                    />
                                )}
                                headerCell={() => CustomMenu(this.state.totalSchedule, this.AddNewModal)}

                            />
                        </Grid>
                    </div>
                    <div className="modal-footer justify-content-center border-0">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                        </div>
                    </div>
                </div>

                <ConfirmationModal
                    message={REMOVE_CLIENT_SCHEDULE_CONFIRMATION_MSG()}
                    showModal={this.state.showRemoveModal}
                    handleYes={() => this.deleteSchedule(this.dataItem.scheduleId, 2, CLIENT_SCHEDULE_REMOVE_SUCCESS_MSG)}
                    handleNo={() => {
                        this.setState({ showRemoveModal: false });
                    }}
                />

                <ConfirmationModal
                    message={ACTIVE_CLIENT_SCHEDULE_CONFIRMATION_MSG()}
                    showModal={this.state.showActivateModal}
                    handleYes={() => this.deleteSchedule(this.dataItem.scheduleId, 1, CLIENT_SCHEDULE_ACTIVE_SUCCESS_MSG)}
                    handleNo={() => {
                        this.setState({ showActivateModal: false });
                    }}
                />

                <ConfirmationModal
                    message={INACTIVE_CLIENT_SCHEDULE_CONFIRMATION_MSG()}
                    showModal={this.state.showInactivateModal}
                    handleYes={() => this.deleteSchedule(this.dataItem.scheduleId, 0, CLIENT_SCHEDULE_INACTIVE_SUCCESS_MSG)}
                    handleNo={() => {
                        this.setState({ showInactivateModal: false });
                    }}
                />


                {this.state.showAddNewScheduleModal && (
                    <div id="add-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <CreateSchedule
                                props={null}
                                onCloseModal={() => this.setState({ showAddNewScheduleModal: false }, () => { this.dataItem = undefined; this.getSchedules(this.state.dataState) })}
                                onOpenModal={() => this.setState({ showAddNewScheduleModal: true })}
                                departmentId={this.state.departmentId}
                                locationId={this.state.locationId}
                             />
                        </Dialog>
                    </div>
                )}
                {this.state.showEditModal && (
                    <div id="Edit-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <CreateSchedule
                                props={this.dataItem}
                                onCloseModal={() => this.setState({ showEditModal: false }, () => { this.dataItem = undefined; this.getSchedules(this.state.dataState) })}
                                onOpenModal={() => this.setState({ showEditModal: false })}
                                departmentId={this.state.departmentId}
                                locationId={this.state.locationId}
                            />
                        </Dialog>
                    </div>
                )}
            </div>
        );
    }
}

export default Schedule;


